// MODULES
import React from "react";

// COMPONENTS
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import QuestionField from "@routes/Cob/components/QuestionField/QuestionField";

// HELPERS
import {createClassName} from "@helpers/utils";
import Select from "../../../../../../../../components/Select/Select";


export default class Collection extends React.PureComponent {

	render() {
		const {props} = this;
		const {index, fields, onSelectChange} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		return (
			<div className={classes}>
				<h3>Erfarenhetsbakgrund</h3>

				<div className={"experienceTable fair"}>
					<div className={"header"}>
						<div className={"headerType"}>
							Finansiella instrument
						</div>
						<div className={"headerExp"}>
							Kunskap och erfarenhet
						</div>
						<div className={"headerField"}>
							Hur ofta gör du affärer?
						</div>
						<div className={"headerField last"}>
							Hur stor är genomsnittsaffären i kronor? (Tusental)
						</div>
					</div>
					<FieldsCollection
						style={{width: "100% !important"}}
						fields={[
							{
								render: (
									<FieldsCollection
										className={"tableRow"}
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Aktier</h4>
														<QuestionField
															Component={Select}
															label="Välj"
															name={"radio_kyc_knowledge_aktier"}
															selectedIndex={fields.radio_kyc_knowledge_aktier.index}
															options={fields.radio_kyc_knowledge_aktier.options}
															onChange={onSelectChange}
														/>
													</React.Fragment>
												),
											},
											{
												render: (
													<QuestionField
														Component={Select}
														label="Välj"
														name={"radio_kyc_transactions_aktier"}
														selectedIndex={fields.radio_kyc_transactions_aktier.index}
														options={fields.radio_kyc_transactions_aktier.options}
														onChange={onSelectChange}
													/>
												),
											},
											{
												render: (
													<QuestionField
														Component={Select}
														label="Välj"
														name={"radio_aml_transaction_size_aktier"}
														selectedIndex={fields.radio_aml_transaction_size_aktier.index}
														options={fields.radio_aml_transaction_size_aktier.options}
														onChange={onSelectChange}
													/>
												),
											}
										]}
									/>
								),
							},
							{
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>Fonder</h4>
														<QuestionField
															Component={Select}
															label="Välj"
															name={"radio_kyc_knowledge_fonder"}
															selectedIndex={fields.radio_kyc_knowledge_fonder.index}
															options={fields.radio_kyc_knowledge_fonder.options}
															onChange={onSelectChange}
														/>
													</React.Fragment>
												),
											},
											{
												render: (
													<QuestionField
														Component={Select}
														label="Välj"
														name={"radio_kyc_transactions_fonder"}
														selectedIndex={fields.radio_kyc_transactions_fonder.index}
														options={fields.radio_kyc_transactions_fonder.options}
														onChange={onSelectChange}
													/>
												),
											},
											{
												render: (
													<QuestionField
														Component={Select}
														label="Välj"
														name={"radio_aml_transaction_size_fonder"}
														selectedIndex={fields.radio_aml_transaction_size_fonder.index}
														options={fields.radio_aml_transaction_size_fonder.options}
														onChange={onSelectChange}
													/>
												),
											}
										]}
									/>
								),
							},
							{
								render: (
									<FieldsCollection
										fields={[
											{
												render: (
													<React.Fragment>
														<h4>ISK / Depå</h4>
														<QuestionField
															Component={Select}
															label="Välj"
															name={"radio_kyc_knowledge_isk"}
															selectedIndex={fields.radio_kyc_knowledge_isk.index}
															options={fields.radio_kyc_knowledge_isk.options}
															onChange={onSelectChange}
														/>
													</React.Fragment>
												),
											},
											{
												render: (
													<QuestionField
														Component={Select}
														label="Välj"
														name={"radio_kyc_transactions_isk"}
														selectedIndex={fields.radio_kyc_transactions_isk.index}
														options={fields.radio_kyc_transactions_isk.options}
														onChange={onSelectChange}
													/>
												),
											},
											{
												render: (
													<QuestionField
														Component={Select}
														label="Välj"
														name={"radio_aml_transaction_size_isk"}
														selectedIndex={fields.radio_aml_transaction_size_isk.index}
														options={fields.radio_aml_transaction_size_isk.options}
														onChange={onSelectChange}
													/>
												),
											}
										]}
									/>
								),
							}
						]}
					/>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/fair-gds-oppna/Fields/collections/CollectionExperience.js